<template>
  <div>
    <el-dialog title="发货" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false"
               width="900px">
      <el-button type="primary" @click="showAddExpress" style="margin-bottom: 15px">添加</el-button>
      <el-table :data="expressList">
        <el-table-column label="发货日期" min-width="100" align="center" prop="expressDate"/>
        <el-table-column label="收货人" min-width="100" align="center" prop="receiverName"/>
        <el-table-column label="联系电话" min-width="100" align="center" prop="receiverMobile"/>
        <el-table-column label="物流公司" min-width="100" align="center" prop="logisticsCompanyName"/>
        <el-table-column label="物流单号" min-width="100" align="center" prop="logisticsNum"/>
        <el-table-column label="物流费用（元）" min-width="120" align="center" prop="logisticsFee"/>
        <el-table-column label="备注" min-width="100" align="center" show-overflow-tooltip prop="expressRemark"/>
        <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button type="text"  @click="deleteItem(scope.$index)">移除</el-button>
            <el-button type="text"  @click="editItem(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="confirmExpress">确认</el-button>
      </div>
    </el-dialog>
    <AddExpressDialog ref="addExpressDialogRef" @success="addExpressCallBack"/>
  </div>
</template>

<script>
import {express} from "@/api/crm/order";
import {mapState} from 'vuex'
import AddExpressDialog from "./addExpressDialog.vue"

export default {
  name: "expressDialog",
  props: {},
  components: {
    AddExpressDialog
  },
  data() {
    return {
      visible: false,
      deliveryOrderId: null,
      expressList: [],
      editItemIndex: null
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  methods: {
    showAddExpress() {
      this.$refs.addExpressDialogRef.open()
    },
    open(deliveryOrderId) {
      this.deliveryOrderId = deliveryOrderId;
      this.visible = true
      this.expressList = []
    },
    addExpressCallBack(editFlag, data) {
      if (editFlag) {
        this.$set(this.expressList, this.editItemIndex, data)
      } else {
        this.expressList.push(data)
      }
    },
    deleteItem(index) {
      this.$confirm('确认移除该条数据吗？').then(() => {
        this.expressList.splice(index, 1)
      }).catch(() => {
      });
    },
    editItem(index, row) {
      this.editItemIndex = index
      this.$refs.addExpressDialogRef.open(row)
    },
    // 确认提交发货列表
    confirmExpress() {
      if (!this.expressList || this.expressList.length === 0) {
        this.msgError('发货列表不能为空')
        return
      }
      const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
      express({
        deliveryOrderId: this.deliveryOrderId,
        expressList: this.expressList
      }).then(response => {
        this.$emit('success')
        this.visible = false
        this.msgSuccess("发货成功");
      }).finally(() => {
        loading.close()
      })
    }
  }
};
</script>
